import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { CountryFlag, Text } from '@reveni-io/reveni-ui'

import BestSellingProductsOriginChartSkeleton from './BestSellingProductsOriginChartSkeleton/BestSellingProductsOriginChartSkeleton'
import * as Styles from './styles'

const BestSellingProductsOriginChart = ({ metrics, loading, regions, onClickCountry }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getCountryName = countryCode => {
    return regions.find(region => region.code === countryCode)?.name || t('País desconocido')
  }

  const getPercentage = value => {
    const maxValue = metrics[0]?.total_count

    return (value * 100) / maxValue
  }

  if (loading) return <BestSellingProductsOriginChartSkeleton />

  return (
    <Styles.Container>
      {metrics?.map((country, index) => (
        <Styles.CountryContainer key={country.country_code} onClick={() => onClickCountry(country.country_code)}>
          <Styles.CountryPosition>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {index + 1}
            </Text>
          </Styles.CountryPosition>
          <Styles.CountryInfoContainer>
            <Styles.CountryName>
              <CountryFlag code={country.country_code} />
              <Text type="bodyMBold">{getCountryName(country.country_code)}</Text>
            </Styles.CountryName>
            <Styles.ProgressBarContainer>
              <Styles.ProgressBar
                animate={{ width: `${getPercentage(country.total_count)}%` }}
                transition={{ duration: 0.8 }}
              />
              <Text type="bodyMBold">{country.total_count}</Text>
            </Styles.ProgressBarContainer>
          </Styles.CountryInfoContainer>
        </Styles.CountryContainer>
      ))}
    </Styles.Container>
  )
}

export default BestSellingProductsOriginChart
